import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IAdminInsightsResult } from '../types/IAdminInsightsResult';

export class AdminInsightsGetConfigurationRequest
    extends Request<{},IAdminInsightsResult> {

    constructor() {
        super('getAdminInsightsConfiguration', {});
    }
}
